import $ from "jquery";
import _ from "lodash";

const DISCOUNT_BUTTON_ID = "#discount-code-apply";
const DISCOUNT_FIELD_ID = "#discount-code-field";
const DISCOUNT_FORM_ID = "#discount-form";
const FAIL_MESSAGE_ID = "#discount-fail";
const SUCCESS_MESSAGE_ID = "#discount-success";
const DISCOUNT_AMOUNT_DISPLAY = "#discount-amount";

const PLAN_SELECT_ID = "#plan-field";
const NUMBER_OF_TEAMS_ID = "#number-of-teams-field";
const NUMBER_OF_PLAYERS_ID = "#number-of-players-field";
const NUMBER_OF_COACHES_ID = "#number-of-team-coaches-field";
const NUMBER_OF_ASSISTANT_COACHES_ID = "#number-of-team-assistants-field";

const BILLING_PERIOD_MONTHLY_ID = 'input[name="billing_period"][value="monthly"]';
const BILLING_PERIOD_ANNUAL_ID = 'input[name="billing_period"][value="annual"]';
const BILLING_PERIOD_NAME = 'input[name="billing_period"]';
const BILLING_PERIOD_GROUP_ID = "#billing-period-group";

const NUMBER_OF_LEAGUE_PLAYERS_ID = "#number-of-league-players-field";
const NUMBER_OF_LEAGUE_COACHES_ID = "#number-of-league-coaches";
const SUBTOTAL_DISPLAY_FIELD_ID = "#subtotal-display-field";
const DISCOUNT_DISPLAY_FIELD_ID = "#discount-display-field";
const TOTAL_DISPLAY_FIELD_ID = "#total-display-field";
const SUBMIT_FIELD_ID = "#submit-button";

const HIDE_CLASS = "d-none";

const OVERRIDE_LICENSE_PLAN_OPTIONS_ID = "#override-license-plan-options";
const OVERRIDE_LICENSE_PLAN_SELECT_ID = "#override-license-plan-field";
const OVERRIDE_LICENSE_TEAM_QUANTITY_ID = "#override-license-team-quantity";
const OVERRIDE_LICENSE_PLAYER_QUANTITY_ID = "#override-license-player-quantity";
const OVERRIDE_LICENSE_COACH_QUANTITY_ID = "#override-license-coach-quantity";

$(() => {
  if ($(OVERRIDE_LICENSE_PLAN_OPTIONS_ID).length > 0) {
    const $planSelect = $(OVERRIDE_LICENSE_PLAN_SELECT_ID);
    $planSelect.on("change", updateOverrideLicenseQuantityInputs);
    updateOverrideLicenseQuantityInputs();
  }

  if ($("#plan-options").length > 0) {
    console.log("Init plan selector");
    const $planSelect = $(PLAN_SELECT_ID);
    $planSelect.on("change", onPlanChanged);

    const $teamsInput = $(NUMBER_OF_TEAMS_ID);
    $teamsInput.on("change keyup", onTeamsChanged);

    const $coachPlayerInput = $(NUMBER_OF_PLAYERS_ID);
    $coachPlayerInput.on("change keyup", onTeamsChanged);

    const $coachAssitantInput = $(NUMBER_OF_ASSISTANT_COACHES_ID);
    $coachAssitantInput.on("change keyup", onTeamsChanged);

    const $coachInput = $(NUMBER_OF_COACHES_ID);
    $coachInput.on("change keyup", onTeamsChanged);

    const $leaguePlayersInput = $(NUMBER_OF_LEAGUE_PLAYERS_ID);
    $leaguePlayersInput.on("change keyup", onLeaguePlayersChanged);

    const $leagueCoachesInput = $(NUMBER_OF_LEAGUE_COACHES_ID);
    $leagueCoachesInput.on("change keyup", onLeagueCoachesChanged);

    const $discountButton = $(DISCOUNT_BUTTON_ID);
    $discountButton.on("click", onApplyDiscount);

    const $billingPeriodInputs = $(BILLING_PERIOD_NAME);
    $billingPeriodInputs.on("change", onBillingPeriodChanged);

    updateTeamsInput($planSelect);
    updateTotalDisplay();
    updateSubscriptionButton();
  }
});

const onApplyDiscount = _.debounce((event) => {
  var discount = $(DISCOUNT_FIELD_ID).val();
  const $planSelect = $(PLAN_SELECT_ID);
  const useGiftPricing = $planSelect.data("pricing") === "gift";

  $.ajax({
    url: "/subscriptions/discount",
    type: "GET",
    data: {
      discount: discount,
      is_gift: useGiftPricing,
    },
    success: function (result) {
      $(DISCOUNT_FORM_ID).addClass("has-success");
      $(DISCOUNT_FORM_ID).removeClass("has-warning");
      $(SUCCESS_MESSAGE_ID).removeClass(HIDE_CLASS);
      $(DISCOUNT_AMOUNT_DISPLAY).text(result.amount_off / 100);
      $(FAIL_MESSAGE_ID).addClass(HIDE_CLASS);
      updateTotalDisplay();
    },
    error: function (result) {
      const errorMessage = result.responseJSON?.message || "Invalid coupon code";

      $(DISCOUNT_FORM_ID).addClass("has-warning");
      $(DISCOUNT_FORM_ID).removeClass("has-success");
      $(SUCCESS_MESSAGE_ID).addClass(HIDE_CLASS);
      $(FAIL_MESSAGE_ID).text(errorMessage).removeClass(HIDE_CLASS);

      // Clear the invalid discount code
      $(DISCOUNT_FIELD_ID).val("");

      // Recalculate pricing without discount
      updateTotalDisplay();
    },
  });
}, 200);

const onPlanChanged = _.debounce((event) => {
  // Show the teams input
  updateTeamsInput($(event.currentTarget));

  // Update the total display
  updateTotalDisplay();
  updateSubscriptionButton();
}, 200);

const onTeamsChanged = _.debounce((event) => {
  updateTotalDisplay();
  updateSubscriptionButton();
}, 200);

const onLeaguePlayersChanged = _.debounce((event) => {
  updateTotalDisplay();
  updateSubscriptionButton();
}, 200);

const onLeagueCoachesChanged = _.debounce((event) => {
  updateTotalDisplay();
  updateSubscriptionButton();
}, 200);

const onBillingPeriodChanged = _.debounce((event) => {
  updateTotalDisplay();
}, 200);

const updateTotalDisplay = () => {
  if (formComplete()) {
    updateTotal();
  } else {
    hideTotal();
  }
};

const updateSubscriptionButton = () => {
  const $submit = $(SUBMIT_FIELD_ID);
  $submit.prop("disabled", !formComplete());
};

const formComplete = () => {
  const $planSelect = $(PLAN_SELECT_ID);
  const $plan = $planSelect.find(":selected");

  if (!$plan || !$plan.val()) {
    return false;
  }

  if ($plan.val() == "league") {
    const $playerInput = $(NUMBER_OF_LEAGUE_PLAYERS_ID);
    const playerCount = parseInt($playerInput.val(), 10);

    const $coachInput = $(NUMBER_OF_LEAGUE_COACHES_ID);
    const coachCount = parseInt($coachInput.val(), 10);

    return playerCount > 0 && playerCount <= 5000 && coachCount > 0 && coachCount <= 500;
  } else if ($plan.val() == "coach_team") {
    const $playerInput = $(NUMBER_OF_PLAYERS_ID);
    const playerCount = parseInt($playerInput.val(), 10);

    const $coachInput = $(NUMBER_OF_COACHES_ID);
    const coachCount = parseInt($coachInput.val(), 10) || 1;

    return playerCount > 0 && coachCount > 0;
  } else if ($plan.val() == "parent") {
    return true;
  } else {
    return true;
  }
};

const updateTotal = () => {
  hideTotal();
  calculateTotal();
};

const hideTotal = () => {
  let $totalDisplayField = $(TOTAL_DISPLAY_FIELD_ID);
  $totalDisplayField.parent().addClass(HIDE_CLASS);
};

const calculateTotal = () => {
  const $planSelect = $(PLAN_SELECT_ID);
  const $plan = $planSelect.find(":selected");

  var data = {
    plan: $plan.val(),
  };

  if ($("#discount-code-field").val()) {
    data.discountCode = $("#discount-code-field").val();
  }

  if ($plan.val() == "league") {
    const $playerInput = $(NUMBER_OF_LEAGUE_PLAYERS_ID);
    data.playerCount = parseInt($playerInput.val(), 10);

    const $coachInput = $(NUMBER_OF_LEAGUE_COACHES_ID);
    data.coachCount = parseInt($coachInput.val(), 10);
  } else if ($plan.val() == "coach_team") {
    const $playerInput = $(NUMBER_OF_PLAYERS_ID);
    const $coachInput = $(NUMBER_OF_COACHES_ID);

    data.playerCount = parseInt($playerInput.val(), 10);
    data.coachCount = parseInt($coachInput.val(), 10) || 1;
  } else if ($plan.val() == "parent") {
    data.playerCount = 1;
    data.coachCount = 1;
  } else if ($plan.val() == "coach") {
    data.playerCount = 0;
    data.coachCount = 1;
  }

  const useGiftPricing = $planSelect.data("pricing") === "gift";
  const url = useGiftPricing ? "/gifts/pricing" : "/subscriptions/pricing";
  data.is_gift = useGiftPricing;

  const $monthlyRadio = $(BILLING_PERIOD_MONTHLY_ID);
  if (billingPeriodInputsVisible()) {
    data.billing_period = $monthlyRadio.is(":checked") ? "monthly" : "annual";
  }

  $.ajax({
    url: url,
    type: "GET",
    data: data,
    success: (pricing) => {
      displayTotalValue(pricing);
    },
    error: (res) => {
      const errorMessage = res.responseJSON?.message || "Unknown error";
      console.error(errorMessage);

      if (res.status === 404 && errorMessage.includes("Monthly pricing is not yet available")) {
        // Reset to annual billing when monthly is not available
        $(BILLING_PERIOD_ANNUAL_ID).prop("checked", true);
        $(BILLING_PERIOD_MONTHLY_ID).prop("checked", false);
        alert("Monthly pricing is not yet available for this plan. Switched to annual billing.");
        // Recalculate with annual pricing
        updateTotalDisplay();
      } else if (res.status === 404) {
        alert(`Pricing not available: ${errorMessage}`);
      } else {
        alert("There was an error while fetching plan pricing. Sorry for any inconvenience.");
      }
    },
  });
};

const displayTotalValue = (pricing) => {
  let $subtotalDisplayField = $(SUBTOTAL_DISPLAY_FIELD_ID);
  let $discountDisplayField = $(DISCOUNT_DISPLAY_FIELD_ID);
  let $totalDisplayField = $(TOTAL_DISPLAY_FIELD_ID);

  if (pricing.discount_amount) {
    let discountString = `-${pricing.discount_amount}`;
    // if (pricing.discount_percent) {
    //   discountString += ` (${pricing.discount_percent}% off)`;
    // }

    $subtotalDisplayField.text(pricing.subtotal);
    $discountDisplayField.text(discountString);

    showDiscountFields();
  } else {
    hideDiscountFields();
  }

  $totalDisplayField.text(pricing.total);
  $totalDisplayField.parent().removeClass(HIDE_CLASS);
};

const hideDiscountFields = () => {
  let $subtotalDisplayField = $(SUBTOTAL_DISPLAY_FIELD_ID);
  let $discountDisplayField = $(DISCOUNT_DISPLAY_FIELD_ID);

  $subtotalDisplayField.addClass(HIDE_CLASS);
  $subtotalDisplayField.prev().addClass(HIDE_CLASS);
  $discountDisplayField.addClass(HIDE_CLASS);
  $discountDisplayField.prev().addClass(HIDE_CLASS);
};

const showDiscountFields = () => {
  let $subtotalDisplayField = $(SUBTOTAL_DISPLAY_FIELD_ID);
  let $discountDisplayField = $(DISCOUNT_DISPLAY_FIELD_ID);

  $subtotalDisplayField.removeClass(HIDE_CLASS);
  $subtotalDisplayField.prev().removeClass(HIDE_CLASS);
  $discountDisplayField.removeClass(HIDE_CLASS);
  $discountDisplayField.prev().removeClass(HIDE_CLASS);
};

const updateTeamsInput = ($planSelect) => {
  const $plan = $planSelect.find(":selected");
  if ($plan && $plan.val() == "league") {
    showLeaguePlayersInput();
    showCoachesInput();
    hideCoachPlayersInput();
    hideCoachAssistantInput();
    hideTeamCoachInput();
    hideBillingPeriodInputs();
  } else if ($plan && $plan.val() == "coach_team") {
    showCoachPlayersInput();
    showCoachAssistantInput();
    showTeamCoachInput();
    hideCoachesInput();
    hideLeaguePlayersInput();
    showBillingPeriodInputs();
  } else if ($plan && $plan.val() == "parent") {
    hideLeaguePlayersInput();
    hideCoachPlayersInput();
    hideCoachAssistantInput();
    hideTeamCoachInput();
    hideCoachesInput();
    showBillingPeriodInputs();
  } else {
    hideLeaguePlayersInput();
    hideCoachPlayersInput();
    hideCoachAssistantInput();
    hideTeamCoachInput();
    hideCoachesInput();
    showBillingPeriodInputs();
  }
};

const showInput = (id) => {
  const $input = $(id);
  if ($input.length) {
    inputGroup($input).removeClass(HIDE_CLASS);
    $input.prop("disabled", false);
  }
};

const hideInput = (id) => {
  const $input = $(id);
  if ($input.length) {
    inputGroup($input).addClass(HIDE_CLASS);
    $input.prop("disabled", true);
  }
};

const inputGroup = ($input) => {
  const $group = $input.closest(".form-group");
  return $group.length ? $group : $input.parent();
};

const updateOverrideLicenseQuantityInputs = () => {
  const plan = $(OVERRIDE_LICENSE_PLAN_SELECT_ID).val();

  $(OVERRIDE_LICENSE_TEAM_QUANTITY_ID).prop("disabled", true);
  hideInput(OVERRIDE_LICENSE_PLAYER_QUANTITY_ID);
  hideInput(OVERRIDE_LICENSE_COACH_QUANTITY_ID);

  if (plan === "coach") {
    $(OVERRIDE_LICENSE_TEAM_QUANTITY_ID).prop("disabled", false);
  } else if (plan === "coach_team") {
    $(OVERRIDE_LICENSE_TEAM_QUANTITY_ID).prop("disabled", false);
    showInput(OVERRIDE_LICENSE_PLAYER_QUANTITY_ID);
    showInput(OVERRIDE_LICENSE_COACH_QUANTITY_ID);
  }
};

const showCoachPlayersInput = () => showInput(NUMBER_OF_PLAYERS_ID);
const hideCoachPlayersInput = () => hideInput(NUMBER_OF_PLAYERS_ID);
const showCoachAssistantInput = () => showInput(NUMBER_OF_ASSISTANT_COACHES_ID);
const hideCoachAssistantInput = () => hideInput(NUMBER_OF_ASSISTANT_COACHES_ID);
const showTeamCoachInput = () => showInput(NUMBER_OF_COACHES_ID);
const hideTeamCoachInput = () => hideInput(NUMBER_OF_COACHES_ID);

const showLeaguePlayersInput = () => {
  showInput(NUMBER_OF_LEAGUE_PLAYERS_ID);
};
const hideLeaguePlayersInput = () => hideInput(NUMBER_OF_LEAGUE_PLAYERS_ID);
const showCoachesInput = () => showInput(NUMBER_OF_LEAGUE_COACHES_ID);
const hideCoachesInput = () => hideInput(NUMBER_OF_LEAGUE_COACHES_ID);

const billingPeriodInputsVisible = () => {
  const $group = $(BILLING_PERIOD_GROUP_ID);
  const $inputs = $(BILLING_PERIOD_NAME);

  if ($group.length === 0 || $inputs.length === 0) {
    return false;
  }

  return !$group.hasClass(HIDE_CLASS) && !$inputs.prop("disabled");
};

const showBillingPeriodInputs = () => {
  const $group = $(BILLING_PERIOD_GROUP_ID);
  const $inputs = $(BILLING_PERIOD_NAME);

  if ($group.length > 0) {
    $group.removeClass(HIDE_CLASS);
  }

  if ($inputs.length > 0) {
    $inputs.prop("disabled", false);
  }
};

const hideBillingPeriodInputs = () => {
  const $group = $(BILLING_PERIOD_GROUP_ID);
  const $inputs = $(BILLING_PERIOD_NAME);

  if ($group.length > 0) {
    $group.addClass(HIDE_CLASS);
  }

  if ($inputs.length > 0) {
    $inputs.prop("disabled", true);
  }
};
